/**
 * ReminderContainer Component
 * Wraps the app and displays active reminders
 */

import React from 'react';
import { useReminder } from '../context/ReminderContext';
import ReminderDisplay from './ReminderDisplay';

const ReminderContainer = ({ children }) => {
  const { activeReminder, preferences, dismissReminder, snoozeReminder } = useReminder();

  return (
    <>
      {children}
      {activeReminder && (
        <ReminderDisplay
          reminder={activeReminder}
          preferences={preferences}
          onDismiss={dismissReminder}
          onSnooze={snoozeReminder}
        />
      )}
    </>
  );
};

export default ReminderContainer;
